import { Button, Select, Row, Col, message, Modal, Spin, Input, DatePicker, Upload } from 'antd';
import { CloseCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Pagination from '@/components/pagination';
import PayoutTable from '@/components/PayoutTable';
import ReviewList from '@/components/ReviewList';
import Schedule from '@/components/Schedule/Schedule';
import api from '@/api/tasker';
import settingsApi from '@/api/settings';
import male from '@/assets/images/male@2x.png';
import female from '@/assets/images/female@2x.png';
import other from '@/assets/images/other@2x.png';
import { defaultInfo, taskType } from '@/typings/allType';
import taskerApi from '@/api/tasker';
import dayjs from 'dayjs';
import publicMethod from '@/utils/publicMethod';
import TaskerPhotos from '@/components/TaskerPhotos';
import TaskerApplicationDetails from '@/components/TaskerApplication';
import taskerCategoriesApi from '@/api/taskerCategories';
import axios from 'axios';
import format from '@/utils/format';
const TaskerDateil = () => {
    const link = useNavigate();
    const [state, setState] = useState<any>({
        ratingInfo: {
            ratingScore: 0,
            totalRatingCount: 0,
        },
        certificateList: [] as any,
    });
    const [info, setInfo] = useState<any>({});
    const [tableData, setTableData] = useState<any[]>([]);
    const [metaData, setMetaData] = useState({
        activeTasks: '0',
        cancelledTasks: '0',
        completedTasks: '0',
        totalHistoryPayout: '0.00',
        totalUpcomingPayout: '0.00',
    });
    const [loading, setLoading] = useState(false);
    const [videoModal, setVideoModal] = useState(false);
    const [totalRecord, setTotalRecord] = useState(1);
    const [activeTag, setActiveTag] = useState(1);
    const [tableTab, setTableTab] = useState(1);
    const [accountModal, setAccountModal] = useState({ disable: false, open: false, id: '', type: 1 });
    const [rejectModalOpen, setRejectModalOpen] = useState(false);
    const [rejectionReason, setRejectionReason] = useState('');
    const [resendingInvite, setResendingInvite] = useState(false);
    const [tierOptions, setTierOptions] = useState<{ value: string; label: string }[]>([]);
    const [listParams, setListParams] = useState<any>({
        pageNum: 1,
        pageSize: 10,
        taskerId: '',
        taskState: 'active',
    });
    const handleChange = (value: string) => {
        const pat = {
            taskerId: info.taskerId,
            isDisable: value === 'Inactive',
        };
        if (value === 'Inactive') {
            setAccountModal({ open: true, disable: true, id: info.taskerId, type: 1 });
            return;
        }
        changeStuatus(pat);
    };
    const changeStuatus = async (pat: defaultInfo) => {
        try {
            await api.changeTaskerStatus({ ...pat });
            setState({ ...state, disabled: pat.isDisable });
            setAccountModal({ open: false, disable: false, id: '', type: 1 });
        } catch (error: any) {
            setState({ ...state, disabled: !pat.isDisable });
            message.error(error);
        }
    };
    const delTasker = async (pat: defaultInfo) => {
        try {
            await api.deleteTasker({ ...pat });
            setAccountModal({ open: false, disable: false, id: '', type: 1 });
            link(-1);
        } catch (error: any) {
            message.error(error);
        }
    };
    // ---- Inline Identity edit (edit in place; the page keeps the same view layout) ----
    const [editing, setEditing] = useState(false);
    const [saving, setSaving] = useState(false);
    const [pendingEdit, setPendingEdit] = useState(false);
    const [editForm, setEditForm] = useState<any>({});
    const [emailOtpSent, setEmailOtpSent] = useState(false);
    const [mobileOtpSent, setMobileOtpSent] = useState(false);
    const [emailVerified, setEmailVerified] = useState(false);
    const [mobileVerified, setMobileVerified] = useState(false);
    const [emailVerifying, setEmailVerifying] = useState(false);
    const [mobileVerifying, setMobileVerifying] = useState(false);
    const [avatarUploading, setAvatarUploading] = useState(false);
    const editField = (k: string, v: any) => {
        // Any change to the email/mobile or its code invalidates a prior "verified" state.
        if (k === 'email' || k === 'emailCode') setEmailVerified(false);
        if (k === 'mobile' || k === 'areaCode' || k === 'mobileCode') setMobileVerified(false);
        setEditForm((prev: any) => ({ ...prev, [k]: v }));
    };
    const enterEdit = () => {
        const s = { ...info, ...state };
        setEditForm({
            firstName: s.firstName ?? '',
            lastName: s.lastName ?? '',
            email: s.email ?? '',
            areaCode: s.areaCode ?? '',
            mobile: s.mobile ?? '',
            gender: s.gender != null && s.gender !== '' ? Number(s.gender) : undefined,
            birthday: s.birthday ? dayjs(s.birthday) : null,
            street: s.street ?? '',
            suburb: s.suburb ?? '',
            state: s.state ?? undefined,
            postcode: s.postcode ?? '',
            selfIntroduction: s.selfIntroduction ?? '',
            avatarUrl: s.avatarUrl ?? '',
            // Originals for change-detection + OTP codes (required only when email/mobile change).
            origEmail: s.email ?? '',
            origAreaCode: s.areaCode ?? '',
            origMobile: s.mobile ?? '',
            emailCode: '',
            mobileCode: '',
        });
        setEmailOtpSent(false);
        setMobileOtpSent(false);
        setEmailVerified(false);
        setMobileVerified(false);
        setActiveTag(1);
        setEditing(true);
    };
    const emailChanged = () => String(editForm.email ?? '').trim() !== String(editForm.origEmail ?? '').trim();
    const mobileChanged = () =>
        String(editForm.mobile ?? '').trim() !== String(editForm.origMobile ?? '').trim() ||
        String(editForm.areaCode ?? '').trim() !== String(editForm.origAreaCode ?? '').trim();
    const sendEmailOtp = async () => {
        try {
            await taskerApi.sendEmailOtp(String(editForm.email).trim());
            setEmailOtpSent(true);
            setEmailVerified(false);
            message.success('OTP sent to the new email');
        } catch (error: any) {
            message.error(error);
        }
    };
    const sendMobileOtp = async () => {
        try {
            await taskerApi.sendMobileOtp(String(editForm.areaCode).trim(), String(editForm.mobile).trim());
            setMobileOtpSent(true);
            setMobileVerified(false);
            message.success('OTP sent to the new number');
        } catch (error: any) {
            message.error(error);
        }
    };
    const verifyEmail = async () => {
        if (!String(editForm.emailCode || '').trim()) {
            message.warning('Enter the OTP first');
            return;
        }
        setEmailVerifying(true);
        try {
            await taskerApi.verifyEmailOtp(String(editForm.email).trim(), String(editForm.emailCode).trim());
            setEmailVerified(true);
            message.success('Email OTP verified');
        } catch (error: any) {
            setEmailVerified(false);
            message.error(typeof error === 'string' ? error : 'Verification failed');
        } finally {
            setEmailVerifying(false);
        }
    };
    const verifyMobile = async () => {
        if (!String(editForm.mobileCode || '').trim()) {
            message.warning('Enter the OTP first');
            return;
        }
        setMobileVerifying(true);
        try {
            await taskerApi.verifyMobileOtp(
                String(editForm.areaCode).trim(),
                String(editForm.mobile).trim(),
                String(editForm.mobileCode).trim()
            );
            setMobileVerified(true);
            message.success('Mobile OTP verified');
        } catch (error: any) {
            setMobileVerified(false);
            message.error(typeof error === 'string' ? error : 'Verification failed');
        } finally {
            setMobileVerifying(false);
        }
    };
    // Upload a picked image to S3 via the shared /upload/file endpoint, then store the returned URL.
    // Returns false so antd never auto-uploads (we handle it manually), matching the Categories page.
    const beforeAvatarUpload = (file: File) => {
        const isImage = file.type.startsWith('image/');
        if (!isImage) {
            message.error('Please choose an image file');
            return false;
        }
        if (file.size > 5 * 1024 * 1024) {
            message.error('Image must be smaller than 5MB');
            return false;
        }
        (async () => {
            setAvatarUploading(true);
            try {
                const formData = new FormData();
                formData.append('file', file);
                const res = await settingsApi.uploadFile(formData);
                editField('avatarUrl', res.data);
                message.success('Photo uploaded');
            } catch (error: any) {
                console.error('avatar upload failed:', error);
                message.error('Could not upload the image. You can paste an image URL instead.');
            } finally {
                setAvatarUploading(false);
            }
        })();
        return false;
    };
    const saveEdit = async () => {
        if (!String(editForm.firstName || '').trim() || !String(editForm.lastName || '').trim()) {
            message.warning('First name and last name are required');
            return;
        }
        if (emailChanged() && !emailVerified) {
            message.warning('Verify the new email with its OTP before saving');
            return;
        }
        if (mobileChanged() && !mobileVerified) {
            message.warning('Verify the new mobile number with its OTP before saving');
            return;
        }
        setSaving(true);
        try {
            await taskerApi.updateTaskerInfo(String(info.taskerId), {
                firstName: String(editForm.firstName).trim(),
                lastName: String(editForm.lastName).trim(),
                email: editForm.email ? String(editForm.email).trim() : undefined,
                areaCode: editForm.areaCode ? String(editForm.areaCode).trim() : undefined,
                mobile: editForm.mobile ? String(editForm.mobile).trim() : undefined,
                gender: editForm.gender != null && editForm.gender !== '' ? Number(editForm.gender) : undefined,
                birthday: editForm.birthday ? dayjs(editForm.birthday).format('YYYY-MM-DD') : undefined,
                street: editForm.street ? String(editForm.street).trim() : undefined,
                suburb: editForm.suburb ? String(editForm.suburb).trim() : undefined,
                state: editForm.state || undefined,
                postcode: editForm.postcode ? String(editForm.postcode).trim() : undefined,
                selfIntroduction: editForm.selfIntroduction ?? undefined,
                avatarUrl: editForm.avatarUrl ? String(editForm.avatarUrl).trim() : undefined,
                emailCode: editForm.emailCode ? String(editForm.emailCode).trim() : undefined,
                mobileCode: editForm.mobileCode ? String(editForm.mobileCode).trim() : undefined,
            });
            message.success('Tasker updated');
            const fullName = `${String(editForm.firstName).trim()} ${String(editForm.lastName).trim()}`.trim();
            const merged = {
                ...info,
                firstName: editForm.firstName,
                lastName: editForm.lastName,
                fullName,
                email: editForm.email,
                mobile: editForm.mobile,
                avatarUrl: editForm.avatarUrl || info.avatarUrl,
            };
            window.sessionStorage.setItem('taskerInfo', JSON.stringify(merged));
            setInfo(merged);
            await getInfo(info.taskerId);
            setEditing(false);
        } catch (error: any) {
            message.error(error);
        } finally {
            setSaving(false);
        }
    };
    const saveReview = async (review: { ratingId: string; ratingScore: number; ratingComment: string }) => {
        try {
            await taskerApi.updateReview(review.ratingId, {
                ratingScore: review.ratingScore,
                ratingComment: review.ratingComment,
            });
            message.success('Review updated');
            getRatingList({ ...listParams, pageNum: 1, targetId: info.taskerId, ratingType: 'CUSTOMER' });
        } catch (error: any) {
            message.error(error);
        }
    };
    const handlePageChange = prop => {
        if (activeTag === 1) {
            setListParams(state => ({ ...state, pageNum: prop }));
            getTaskList({ ...listParams, pageNum: prop });
        } else if (activeTag === 2) {
            setListParams(state => ({ ...state, pageNum: prop }));
            getTaskList({
                ...listParams,
                pageNum: prop,
                taskerId: info.taskerId,
                taskState: tableTab === 1 ? 'active' : tableTab === 2 ? 'completed' : 'cancelled',
            });
        } else if (activeTag === 3) {
            setListParams(state => ({ ...state, pageNum: prop }));
            getRatingList({ ...listParams, pageNum: prop, targetId: listParams.taskerId, ratingType: 'CUSTOMER' });
        } else {
            setListParams(state => ({ ...state, pageNum: prop }));
            getPaymentList({
                ...listParams,
                pageNum: prop,
            });
        }
    };
    const changeTableTab = (key: number) => {
        setTableTab(key);
        setListParams(state => ({
            ...state,
            pageNum: 1,
            taskerId: info.taskerId,
            taskState: key === 1 || key === 4 ? 'active' : key === 2 || key === 5 ? 'completed' : 'cancelled',
        }));
        if (key < 4) {
            getTaskList({
                ...listParams,
                pageNum: 1,
                taskerId: info.taskerId,
                taskState: key === 1 ? 'active' : key === 2 ? 'completed' : 'cancelled',
            });
        } else {
            getPaymentList({
                ...listParams,
                pageNum: 1,
                taskerId: info.taskerId,
                taskState: key === 4 ? 'active' : 'completed',
            });
        }
    };
    const changeActiveTag = (key: number) => {
        setActiveTag(key);
        setTotalRecord(0);
        setTableTab(1);
        setListParams({ ...listParams, pageNum: 1, taskState: 'active' });
        if (key === 1) {
            getTaskList({ ...listParams, pageNum: 1, taskState: 'active' });
        } else if (key === 2) {
            getTaskList({
                ...listParams,
                pageNum: 1,
                taskerId: info.taskerId,
                taskState: 'active',
            });
        } else if (key === 3) {
            getRatingList({ ...listParams, pageNum: 1, targetId: info.taskerId, ratingType: 'TASKER' });
        } else {
            setTableTab(4);
            getPaymentList({ ...listParams, pageNum: 1, taskState: 'active' });
        }
    };
    const getTaskList = async pat => {
        setLoading(true);
        try {
            const res = await api.getTaskerTaskList({ ...pat });
            const list = res.data.records.map(item => {
                return Object.assign(item, {
                    taskPublishTime: item.taskPublishTime ? window.utils.formatTimeMDY(item.taskPublishTime) : '-',
                    taskWorkTime: item.workStartTime
                        ? window.utils.formatWorkPeriod(
                              //   item.workStartDate,
                              item.workStartTime,
                              //   item.workEndDate,
                              item.workEndTime
                          )
                        : '-',
                });
            });
            setMetaData({ ...metaData, ...res.data.metaData });
            setTableData(list);
            setTotalRecord(+res.data.total);
        } catch (error: any) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };
    const getRatingList = async pat => {
        setLoading(true);
        try {
            const res = await api.getCustomerRatingList({ ...pat });
            const list = res.data.records;
            setTableData(list);
            setTotalRecord(+res.data.total);
        } catch (error: any) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };
    const getPaymentList = async pat => {
        setLoading(true);
        try {
            const res = await api.getTaskerPaymentrecordList({ ...pat });
            const list = res.data.records.map(item => {
                return Object.assign(item, {
                    taskWorkTime: item.workStartTime
                        ? window.utils.formatWorkPeriod(
                              //   item.workStartDate,
                              item.workStartTime,
                              //   item.workEndDate,
                              item.workEndTime
                          )
                        : '-',
                });
            });
            setTableData(list);
            setMetaData({ ...metaData, ...res.data.metaData });
            setTotalRecord(+res.data.total);
        } catch (error: any) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };
    const getInfo = async taskerId => {
        try {
            const res = await api.getTaskerInfo({ taskerId });
            const val = res.data;
            val.lastLogin = val.lastLogin ? window.utils.formatTimeHMSMDY(val.lastLogin) : '-';
            val.timeOnline = val.timeOnline ? window.utils.formatTimeMin(+val.timeOnline) : '0min';
            val.profileUpdateTime = val.profileUpdateTime ? window.utils.formatTimeHMSMDY(val.profileUpdateTime) : '-';
            val.certificateList = val.certificateList
                ? val.certificateList.map(item => {
                      return Object.assign(item, { createTime: window.utils.formatFileTime(item.createTime) });
                  })
                : [];
            setState({ ...state, ...res.data });
        } catch (error: any) {
            message.error(error);
        }
    };
    const [gallery, setGallery] = useState<string[]>([]);
    const getGallery = async taskerId => {
        try {
            const res = await api.getTaskerGallery(taskerId);
            const imgList: string[] = [];
            res.data.forEach(i => {
                imgList.push(i.imageUrl);
            });
            setGallery(imgList);
        } catch (error: any) {
            message.error(error);
        }
    };
    const [taskerCalendar, setTaskerCalendar] = useState<{ localDate: string; list: taskType[] }[]>([]);
    const getTaskerCalendar = async (taskerId: string) => {
        try {
            const res = await taskerApi.getTaskerCalendarList(taskerId);

            const list: any = [];
            for (const key in res.data.task) {
                list.push({
                    localDate: key,
                    list: res.data.task[key],
                });
            }
            setTaskerCalendar(list);
        } catch (error: any) {
            message.error(error);
        }
    };
    useEffect(() => {
        const info = JSON.parse(window.sessionStorage.getItem('taskerInfo') ?? '{}');
        if (info.taskerId) {
            getInfo(info.taskerId);
            getGallery(info.taskerId);
            getTaskerCalendar(info.taskerId);
            setListParams(state => ({
                ...state,
                taskerId: info.taskerId,
                taskState: tableTab === 1 ? 'active' : tableTab === 2 ? 'completed' : 'cancelled',
            }));
            setInfo({ ...info });
        }
        // The list's "Edit" action sets this flag so the page opens straight into edit mode.
        if (window.sessionStorage.getItem('taskerEditOpen') === '1') {
            window.sessionStorage.removeItem('taskerEditOpen');
            setPendingEdit(true);
        }
    }, []);
    useEffect(() => {
        if (pendingEdit && state.taskerId) {
            enterEdit();
            setPendingEdit(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pendingEdit, state.taskerId]);
    const [downLoadIndex, setDownLoadIndex] = useState(-1);
    const downLoad = (imageUrl: string, fileName: string, index: number) => {
        setDownLoadIndex(index);
        axios
            .get(imageUrl, {
                responseType: 'blob',
                params: {
                    random: Math.random(),
                },
            })
            .then(res => {
                const url = URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${fileName}.png`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setDownLoadIndex(-1);
                message.success('download successful!');
            })
            .catch(err => {
                message.error('Encountered some problems, please try again later');
                setDownLoadIndex(-1);
            });
    };
    const getTierOptions = async () => {
        try {
            const res = await taskerCategoriesApi.getList({ pageNum: 1, pageSize: 500 });
            setTierOptions((res.data ?? []).map(o => ({ value: String(o.taskerCategoryId), label: o.categoryName })));
        } catch (error: any) {
            message.error(error);
        }
    };
    useEffect(() => {
        getTierOptions();
    }, []);

    const currentTier =
        state.taskerCategoryId != null && state.taskerCategoryId !== '' ? String(state.taskerCategoryId) : undefined;
    const handleTierChange = async (value: string | null) => {
        try {
            await api.updateTaskerTaskerCategory(String(info.taskerId), value);
            message.success('Tasker tier updated');
            setState(prev => ({ ...prev, taskerCategoryId: value }));
        } catch (error: any) {
            message.error(error);
        }
    };

    const resendSetupInvite = async () => {
        setResendingInvite(true);
        try {
            await api.resendSetupInvite(String(info.taskerId));
            message.success(`Set-up email sent to ${state.email ?? info.email}`);
        } catch (error: any) {
            message.error(error);
        } finally {
            setResendingInvite(false);
        }
    };

    const handleApproval = async (approvalStatus: 'approved' | 'rejected', reason?: string) => {
        if (!info.taskerId) {
            return;
        }
        try {
            await api.updateTaskerApproval(String(info.taskerId), approvalStatus, reason);
            message.success(
                approvalStatus === 'rejected'
                    ? 'Tasker rejected'
                    : state.hasPassword === false
                    ? 'Tasker approved. They have been emailed a link to set their password.'
                    : 'Tasker approved'
            );
            setRejectModalOpen(false);
            setRejectionReason('');
            await getInfo(info.taskerId);
        } catch (error: any) {
            message.error(error);
        }
    };

    const submitReject = () => {
        const reason = rejectionReason.trim();
        if (!reason) {
            message.warning('Please enter a rejection reason');
            return;
        }
        handleApproval('rejected', reason);
    };

    const getImageSize = (imageUrl: string) => {
        const urlParams = imageUrl.split('&');
        const imageSize =
            urlParams.length && urlParams[1] && urlParams[1].includes('x-nt-content-length=')
                ? Math.ceil(Number(urlParams[1].split('=')[1]) / 1024)
                : 12;
        return imageSize + ' Kb ';
    };
    return (
        <div className="page-main tasker-details">
            <div className="page-title flex-between">
                <div>
                    <img
                        className="back-icon"
                        src={require('@/assets/images/back-icon.png')}
                        alt="back-icon"
                        onClick={() => {
                            link(-1);
                        }}
                    />
                    Tasker Details <span className="customer-name">({info.fullName ?? '-'})</span>
                </div>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    {(state.approvalStatus === 'pending' || state.approvalStatus === 'rejected') && (
                        <span style={{ marginRight: 8, fontSize: 16, fontWeight: 500 }}>
                            Approval: <span style={{ textTransform: 'capitalize' }}>{state.approvalStatus}</span>
                            {state.approvalStatus === 'rejected' && state.approvalRejectionReason
                                ? ` — ${state.approvalRejectionReason}`
                                : ''}
                        </span>
                    )}
                    {state.approvalStatus === 'approved' && state.hasPassword === false && (
                        <>
                            <span style={{ marginRight: 8, fontSize: 16, fontWeight: 500 }}>
                                Waiting for the tasker to set a password
                            </span>
                            <Button loading={resendingInvite} onClick={resendSetupInvite}>
                                Resend set-up email
                            </Button>
                        </>
                    )}
                    {(state.approvalStatus === 'pending' || state.approvalStatus === 'rejected') && (
                        <Button type="primary" onClick={() => handleApproval('approved')}>
                            Approve
                        </Button>
                    )}
                    {state.approvalStatus === 'pending' && (
                        <Button danger onClick={() => setRejectModalOpen(true)}>
                            Reject
                        </Button>
                    )}
                    {editing ? (
                        <>
                            <Button onClick={() => setEditing(false)}>Cancel</Button>
                            <Button type="primary" loading={saving} onClick={saveEdit}>
                                Save
                            </Button>
                        </>
                    ) : (
                        <>
                            <Button type="primary" onClick={enterEdit}>
                                Edit
                            </Button>
                            <Button
                                className="delete-btn"
                                danger
                                onClick={() => {
                                    setAccountModal({
                                        disable: false,
                                        open: true,
                                        id: state.taskerId,
                                        type: 2,
                                    });
                                }}
                            >
                                Delete
                            </Button>
                        </>
                    )}
                </div>
            </div>
            {loading ? (
                <div className="data_loading flex-center">
                    <Spin />
                </div>
            ) : (
                <>
                    <div className="customer-tags">
                        <div
                            className={activeTag === 1 ? 'customer-tag customer-tag-active' : 'customer-tag'}
                            onClick={() => {
                                changeActiveTag(1);
                            }}
                        >
                            Identity information
                        </div>
                        <div
                            className={activeTag === 2 ? 'customer-tag customer-tag-active' : 'customer-tag'}
                            onClick={() => {
                                changeActiveTag(2);
                            }}
                        >
                            Tasks
                        </div>
                        <div
                            className={activeTag === 3 ? 'customer-tag customer-tag-active' : 'customer-tag'}
                            onClick={() => {
                                changeActiveTag(3);
                            }}
                        >
                            Reviews
                        </div>
                        <div
                            className={activeTag === 4 ? 'customer-tag customer-tag-active' : 'customer-tag'}
                            onClick={() => {
                                changeActiveTag(4);
                            }}
                        >
                            Payout information
                        </div>
                    </div>
                    {activeTag === 1 ? (
                        <div className="customer-card">
                            <div className="customer-info">
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <div className="customer-avatar">
                                        <img src={editing ? editForm.avatarUrl || '' : info.avatarUrl || ''} alt="" />
                                    </div>
                                    {editing && (
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: 6,
                                                marginTop: 8,
                                                width: 200,
                                            }}
                                        >
                                            <Upload
                                                accept="image/*"
                                                maxCount={1}
                                                showUploadList={false}
                                                beforeUpload={beforeAvatarUpload}
                                            >
                                                <Button size="small" block loading={avatarUploading}>
                                                    {avatarUploading ? 'Uploading…' : 'Change photo'}
                                                </Button>
                                            </Upload>
                                            <Input
                                                size="small"
                                                placeholder="or paste image URL"
                                                value={editForm.avatarUrl}
                                                onChange={e => editField('avatarUrl', e.target.value)}
                                            />
                                        </div>
                                    )}
                                </div>
                                <div className="customer-base">
                                    <div className="customer-name">
                                        {editing ? (
                                            <span style={{ display: 'inline-flex', gap: 8, flexWrap: 'wrap' }}>
                                                <Input
                                                    style={{ width: 150 }}
                                                    placeholder="First name"
                                                    value={editForm.firstName}
                                                    maxLength={50}
                                                    onChange={e => editField('firstName', e.target.value)}
                                                />
                                                <Input
                                                    style={{ width: 150 }}
                                                    placeholder="Last name"
                                                    value={editForm.lastName}
                                                    maxLength={50}
                                                    onChange={e => editField('lastName', e.target.value)}
                                                />
                                                <Select
                                                    style={{ width: 120 }}
                                                    placeholder="Gender"
                                                    value={editForm.gender}
                                                    onChange={v => editField('gender', v)}
                                                    options={[
                                                        { value: 1, label: 'Male' },
                                                        { value: 2, label: 'Female' },
                                                        { value: 0, label: 'Other' },
                                                    ]}
                                                />
                                            </span>
                                        ) : (
                                            <>
                                                {info.fullName ?? '-'}
                                                <img
                                                    src={
                                                        +state.gender === 1
                                                            ? male
                                                            : +state.gender === 2
                                                            ? female
                                                            : other
                                                    }
                                                    className="gender_icon"
                                                    style={{ marginLeft: 8 }}
                                                    alt=""
                                                />
                                            </>
                                        )}
                                        <div className="customer-status">
                                            <Select
                                                className={
                                                    state.disabled
                                                        ? 'select-input select-disable'
                                                        : 'select-input select-enable'
                                                }
                                                defaultValue="Active"
                                                style={{ width: 88 }}
                                                onChange={val => {
                                                    handleChange(val);
                                                }}
                                                value={state.disabled ? 'Inactive' : 'Active'}
                                                options={[
                                                    { value: 'Active', label: 'Active' },
                                                    { value: 'Inactive', label: 'Inactive' },
                                                ]}
                                                suffixIcon={
                                                    <img
                                                        src={require('@/assets/images/selected.png')}
                                                        style={{ width: 16, height: 16 }}
                                                    />
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="customer-star" onClick={() => changeActiveTag(2)}>
                                        <img src={require('@/assets/images/star.png')} alt="" />
                                        {state.ratingInfo.ratingScore ?? 0}
                                        <span>({state.ratingInfo.totalRatingCount ?? '0'})</span>
                                    </div>
                                    <div className="customer-categories">
                                        <div className="customer-categories-text">Market Categories:</div>
                                        <div className="customer-categories-list">
                                            {/* Falls back to the legacy flat list when the backend predates the split. */}
                                            {(state.marketCategoryList ?? state.taskerCategoryList ?? []).length ? (
                                                (state.marketCategoryList ?? state.taskerCategoryList).map(c => (
                                                    <span className="category-i" key={c.categoryId}>
                                                        {c.categoryName}
                                                    </span>
                                                ))
                                            ) : (
                                                <span>-</span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="customer-categories">
                                        <div className="customer-categories-text">B2B Categories:</div>
                                        <div className="customer-categories-list">
                                            {(state.b2bCategoryList ?? []).length ? (
                                                state.b2bCategoryList.map(c => (
                                                    <span className="category-i" key={c.categoryId}>
                                                        {c.categoryName}
                                                    </span>
                                                ))
                                            ) : (
                                                <span>-</span>
                                            )}
                                        </div>
                                    </div>
                                    {state.approvalStatus === 'approved' && (
                                        <div className="customer-categories" style={{ alignItems: 'center' }}>
                                            <div className="customer-categories-text">Tasker Tier:</div>
                                            <Select
                                                style={{ width: 180 }}
                                                placeholder="Select tier"
                                                allowClear
                                                value={currentTier}
                                                options={tierOptions}
                                                onChange={val => handleTierChange(val ? String(val) : null)}
                                            />
                                        </div>
                                    )}
                                    <div className="customer-email">
                                        Email Address:{' '}
                                        {editing ? (
                                            <span
                                                style={{
                                                    display: 'inline-flex',
                                                    gap: 8,
                                                    marginLeft: 8,
                                                    alignItems: 'center',
                                                    flexWrap: 'wrap',
                                                }}
                                            >
                                                <Input
                                                    style={{ width: 260 }}
                                                    value={editForm.email}
                                                    onChange={e => editField('email', e.target.value)}
                                                />
                                                {emailChanged() && (
                                                    <>
                                                        <Button size="small" onClick={sendEmailOtp}>
                                                            {emailOtpSent ? 'Resend OTP' : 'Send OTP'}
                                                        </Button>
                                                        <Input
                                                            style={{ width: 120 }}
                                                            placeholder="Email OTP"
                                                            value={editForm.emailCode}
                                                            onChange={e => editField('emailCode', e.target.value)}
                                                        />
                                                        {emailVerified ? (
                                                            <span style={{ color: '#52c41a', fontWeight: 500 }}>
                                                                ✓ Verified
                                                            </span>
                                                        ) : (
                                                            <Button
                                                                size="small"
                                                                type="primary"
                                                                ghost
                                                                loading={emailVerifying}
                                                                onClick={verifyEmail}
                                                            >
                                                                Verify
                                                            </Button>
                                                        )}
                                                    </>
                                                )}
                                            </span>
                                        ) : (
                                            <span>{info.email}</span>
                                        )}
                                    </div>
                                    <div className="customer-mobile">
                                        Mobile Number:{' '}
                                        {editing ? (
                                            <span
                                                style={{
                                                    display: 'inline-flex',
                                                    gap: 8,
                                                    marginLeft: 8,
                                                    alignItems: 'center',
                                                    flexWrap: 'wrap',
                                                }}
                                            >
                                                <Input
                                                    style={{ width: 80 }}
                                                    placeholder="+61"
                                                    value={editForm.areaCode}
                                                    onChange={e => editField('areaCode', e.target.value)}
                                                />
                                                <Input
                                                    style={{ width: 180 }}
                                                    value={editForm.mobile}
                                                    onChange={e => editField('mobile', e.target.value)}
                                                />
                                                {mobileChanged() && (
                                                    <>
                                                        <Button size="small" onClick={sendMobileOtp}>
                                                            {mobileOtpSent ? 'Resend OTP' : 'Send OTP'}
                                                        </Button>
                                                        <Input
                                                            style={{ width: 120 }}
                                                            placeholder="Mobile OTP"
                                                            value={editForm.mobileCode}
                                                            onChange={e => editField('mobileCode', e.target.value)}
                                                        />
                                                        {mobileVerified ? (
                                                            <span style={{ color: '#52c41a', fontWeight: 500 }}>
                                                                ✓ Verified
                                                            </span>
                                                        ) : (
                                                            <Button
                                                                size="small"
                                                                type="primary"
                                                                ghost
                                                                loading={mobileVerifying}
                                                                onClick={verifyMobile}
                                                            >
                                                                Verify
                                                            </Button>
                                                        )}
                                                    </>
                                                )}
                                            </span>
                                        ) : (
                                            <span>{info.mobile}</span>
                                        )}
                                    </div>
                                    <div className="customer-mobile">
                                        Age:
                                        <span>
                                            {state.birthday
                                                ? dayjs().get('year') - dayjs(state.birthday).get('year')
                                                : '-'}
                                        </span>
                                    </div>
                                    <div className="customer-mobile">
                                        Registered Date: <span>{format.formatTimeMDY(state.createTime)}</span>
                                    </div>
                                    <div className="customer-mobile">
                                        Last completed task:{' '}
                                        <span>{format.formatTimeMDY(state.lastCompletedTask)}</span>
                                    </div>
                                    <div className="customer-mobile">
                                        Last Online: <span>{format.formatTimeMDY(state.lastOnline)}</span>
                                    </div>
                                    {editing && (
                                        <>
                                            <div className="customer-mobile" style={{ alignItems: 'center' }}>
                                                Birthday:{' '}
                                                <DatePicker
                                                    style={{ marginLeft: 8 }}
                                                    value={editForm.birthday || null}
                                                    onChange={d => editField('birthday', d)}
                                                />
                                            </div>
                                            <div className="customer-mobile">
                                                Street:{' '}
                                                <Input
                                                    style={{ width: 320, marginLeft: 8 }}
                                                    value={editForm.street}
                                                    maxLength={100}
                                                    onChange={e => editField('street', e.target.value)}
                                                />
                                            </div>
                                            <div
                                                className="customer-mobile"
                                                style={{
                                                    display: 'flex',
                                                    gap: 12,
                                                    alignItems: 'center',
                                                    flexWrap: 'wrap',
                                                }}
                                            >
                                                Suburb:
                                                <Input
                                                    style={{ width: 200 }}
                                                    value={editForm.suburb}
                                                    maxLength={50}
                                                    onChange={e => editField('suburb', e.target.value)}
                                                />
                                                State:
                                                <Select
                                                    style={{ width: 110 }}
                                                    value={editForm.state}
                                                    allowClear
                                                    placeholder="State"
                                                    onChange={v => editField('state', v)}
                                                    options={['NSW', 'VIC', 'QLD', 'SA', 'WA', 'TAS', 'ACT', 'NT'].map(
                                                        s => ({ value: s, label: s })
                                                    )}
                                                />
                                                Postcode:
                                                <Input
                                                    style={{ width: 110 }}
                                                    value={editForm.postcode}
                                                    maxLength={4}
                                                    onChange={e => editField('postcode', e.target.value)}
                                                />
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    ) : activeTag === 4 ? (
                        <div className="page-total">
                            <div className="total-item total-item-c" style={{ flex: 'unset', padding: 20, rowGap: 12 }}>
                                Total Upcoming Amount
                                <span>
                                    $
                                    {metaData.totalUpcomingPayout
                                        ? publicMethod.formatPrice(metaData.totalUpcomingPayout)
                                        : '0.00'}
                                </span>
                            </div>
                            <div className="total-item total-item-c" style={{ flex: 'unset', padding: 20, rowGap: 12 }}>
                                Total History Amount
                                <span>
                                    $
                                    {metaData.totalHistoryPayout
                                        ? publicMethod.formatPrice(metaData.totalHistoryPayout)
                                        : '0.00'}
                                </span>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                    {activeTag === 1 && state.application ? (
                        <TaskerApplicationDetails
                            application={state.application}
                            onSave={async values => {
                                await api.updateTaskerApplication(String(info.taskerId), values);
                                message.success('Information saved');
                                await getInfo(info.taskerId);
                            }}
                        />
                    ) : null}
                    {activeTag === 1 ? (
                        <div className="tasker-card" style={{ paddingBottom: 24 }}>
                            <div className="tasker-card-left">
                                <div className="tasker-introduce">
                                    <div>
                                        <h3>Video</h3>
                                        {state.selfIntroductionVideo ? (
                                            <div className="tasker-video" onClick={() => setVideoModal(true)}>
                                                <video className="video_box" src={state.selfIntroductionVideo}></video>
                                            </div>
                                        ) : (
                                            <div className="tasker-video">No video</div>
                                        )}
                                    </div>
                                    <div>
                                        <h3>Description</h3>
                                        {editing ? (
                                            <Input.TextArea
                                                rows={4}
                                                value={editForm.selfIntroduction}
                                                onChange={e => editField('selfIntroduction', e.target.value)}
                                            />
                                        ) : (
                                            <div className="tasker-des">
                                                {state.selfIntroduction
                                                    ? RegExp(/\n/).test(state.taskDescription)
                                                        ? state.selfIntroduction.split('\n').map((t, index) => {
                                                              return (
                                                                  <div
                                                                      className="font-r14"
                                                                      key={'selfIntroduction' + index}
                                                                  >
                                                                      {t}
                                                                  </div>
                                                              );
                                                          })
                                                        : state.selfIntroduction
                                                    : '-'}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <TaskerPhotos imageArray={gallery} />
                                <div className="tasker-Statistics-time">
                                    <div>
                                        <div className="tasker-Statistics-value">{state.lastLogin ?? '-'}</div>
                                        <div className="tasker-Statistics-label">Last login</div>
                                    </div>
                                    <div>
                                        <div className="tasker-Statistics-value">{state.profileUpdateTime ?? '-'}</div>
                                        <div className="tasker-Statistics-label">Profile updates</div>
                                    </div>
                                </div>
                                <div className="tasker-Statistics-number">
                                    <div>
                                        <div className="tasker-Statistics-value">{state.timeOnline ?? '-'}</div>
                                        <div className="tasker-Statistics-label">Time online</div>
                                    </div>
                                    <div>
                                        <div className="tasker-Statistics-value">{state.tasksSent ?? '0'}</div>
                                        <div className="tasker-Statistics-label">Tasks sent</div>
                                    </div>
                                    <div>
                                        <div className="tasker-Statistics-value">{state.tasksCompleted ?? '0'}</div>
                                        <div className="tasker-Statistics-label">Tasks Completed</div>
                                    </div>
                                    <div>
                                        <div className="tasker-Statistics-value">{state.tasksDeclined ?? '0'}</div>
                                        <div className="tasker-Statistics-label">Tasks declined</div>
                                    </div>
                                    <div>
                                        <div className="tasker-Statistics-value">{state.completionRate ?? '0'}</div>
                                        <div className="tasker-Statistics-label">Completion rate</div>
                                    </div>
                                </div>
                                <div className="tasker-Statistics"></div>
                            </div>
                            <div className="tasker-card-right">
                                <div className="tasker-schedule">
                                    <Schedule data={taskerCalendar} />
                                </div>
                                {state.certificateList.length ? (
                                    <>
                                        {state.certificateList.map((item, i) => {
                                            return (
                                                <div className="Certificate" key={`Certificate-${i}`}>
                                                    <img src={item.certificateUrl} className="Certificate-file"></img>
                                                    <div>
                                                        <div className="Certificate-name">
                                                            {item.certificateName ?? '-'}
                                                        </div>
                                                        <div className="Certificate-size">
                                                            {getImageSize(item.certificateUrl)}
                                                            {item.createTime ? item.createTime : 'Feb 2022 at 11:30 AM'}
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="Certificate-download"
                                                        style={{ cursor: downLoadIndex === i ? 'no-drop' : 'pointer' }}
                                                    >
                                                        {downLoadIndex === i ? (
                                                            <LoadingOutlined className="down-load-icon" />
                                                        ) : (
                                                            ''
                                                        )}
                                                        <img
                                                            src={require('@/assets/images/download.png')}
                                                            alt=""
                                                            onClick={() => {
                                                                if (downLoadIndex > -1) {
                                                                    if (downLoadIndex === 1) {
                                                                        return;
                                                                    } else {
                                                                        message.warning(
                                                                            'There is a download task in progress, please try again later.'
                                                                        );
                                                                        return;
                                                                    }
                                                                }
                                                                downLoad(item.certificateUrl, item.certificateName, i);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </>
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                    ) : activeTag === 2 ? (
                        <div className="table">
                            <div className="tabs-table">
                                <div
                                    className={
                                        tableTab === 1 ? 'tabs-table-item tabs-table-item-active' : 'tabs-table-item'
                                    }
                                    onClick={() => {
                                        changeTableTab(1);
                                    }}
                                >
                                    Active tasks ({metaData.activeTasks})
                                </div>
                                <div
                                    className={
                                        tableTab === 2 ? 'tabs-table-item tabs-table-item-active' : 'tabs-table-item'
                                    }
                                    onClick={() => {
                                        changeTableTab(2);
                                    }}
                                >
                                    Completed tasks ({metaData.completedTasks})
                                </div>
                                <div
                                    className={
                                        tableTab === 3 ? 'tabs-table-item tabs-table-item-active' : 'tabs-table-item'
                                    }
                                    onClick={() => {
                                        changeTableTab(3);
                                    }}
                                >
                                    Cancelled tasks ({metaData.cancelledTasks})
                                </div>
                            </div>
                            {totalRecord ? (
                                <>
                                    <div className="table-th">
                                        <Row>
                                            <Col span={5}>Task</Col>
                                            <Col span={4}>Customer</Col>
                                            <Col span={3}>Category</Col>
                                            <Col span={4}>Task Value</Col>
                                            <Col span={4}>Posted Date</Col>
                                            <Col span={4}>Task Date</Col>
                                        </Row>
                                    </div>
                                    {tableData.map((item, index) => (
                                        <Row className="table-tr" key={index}>
                                            <Col span={5}>
                                                <div
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                        window.sessionStorage.setItem(
                                                            'taskInfo',
                                                            JSON.stringify({
                                                                userId: info.taskerId,
                                                                taskId: item.taskId,
                                                            })
                                                        );
                                                        link(`/task/detail?type=${window.btoa('tasker')}`);
                                                    }}
                                                >
                                                    {item.taskTitle}
                                                    <div className="desc_tip two-line-text">{item.taskDescription}</div>
                                                </div>
                                            </Col>
                                            <Col span={4}>{(item || {})?.customer?.firstName ?? '-'}</Col>
                                            <Col span={3}>{(item || {}).taskCategory.categoryName ?? '-'}</Col>
                                            <Col span={4}>
                                                $
                                                {item.actualRemunerationAmount
                                                    ? publicMethod.formatPrice(item.actualRemunerationAmount)
                                                    : '0.00'}
                                            </Col>
                                            <Col span={4}>{item.taskPublishTime}</Col>
                                            <Col span={4}>{item.taskWorkTime}</Col>
                                        </Row>
                                    ))}
                                    <Pagination
                                        total={totalRecord}
                                        pageChange={handlePageChange}
                                        pageNo={listParams.pageNum}
                                    />
                                </>
                            ) : (
                                <div className="no-data flex-center">No data</div>
                            )}
                        </div>
                    ) : activeTag === 3 ? (
                        +totalRecord > 0 ? (
                            <>
                                <ReviewList tableData={tableData} editable={editing} onSaveReview={saveReview} />
                                <Pagination
                                    total={totalRecord}
                                    pageChange={handlePageChange}
                                    pageNo={listParams.pageNum}
                                />
                            </>
                        ) : (
                            <div className="no-data flex-center">No data</div>
                        )
                    ) : (
                        <div className="table">
                            <div className="tabs-table" style={{ margin: '24px 0' }}>
                                <div
                                    className={
                                        tableTab === 4 ? 'tabs-table-item tabs-table-item-active' : 'tabs-table-item'
                                    }
                                    onClick={() => {
                                        changeTableTab(4);
                                    }}
                                >
                                    Upcoming payout
                                </div>
                                <div
                                    className={
                                        tableTab === 5 ? 'tabs-table-item tabs-table-item-active' : 'tabs-table-item'
                                    }
                                    onClick={() => {
                                        changeTableTab(5);
                                    }}
                                >
                                    History payout
                                </div>
                            </div>
                            {+totalRecord > 0 ? (
                                <>
                                    <PayoutTable tableData={tableData} showPayOut={tableTab === 5} />
                                    <Pagination
                                        total={totalRecord}
                                        pageChange={handlePageChange}
                                        pageNo={listParams.pageNum}
                                    />
                                </>
                            ) : (
                                <div className="no-data flex-center">No data</div>
                            )}
                        </div>
                    )}
                </>
            )}

            <Modal width={560} maskClosable={false} centered={true} open={accountModal.open} closeIcon={<></>}>
                <div className="modal-title">{accountModal.type === 1 ? 'Disabled account' : 'Delete account'}</div>
                <div className="modal-tip tip-font-20">
                    {accountModal.type === 1
                        ? 'Are you sure you want to disable this account?'
                        : 'Are you sure you want to delete this account?'}
                </div>
                <div className="flex-center" style={{ marginTop: 30, columnGap: 20 }}>
                    <Button
                        className="submit-btn"
                        onClick={() => {
                            setAccountModal({ disable: false, open: false, id: '', type: 1 });
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        className="submit-btn"
                        type="primary"
                        onClick={() => {
                            accountModal.type === 1
                                ? changeStuatus({
                                      taskerId: accountModal.id,
                                      isDisable: true,
                                  })
                                : delTasker({ taskerId: accountModal.id });
                        }}
                    >
                        {accountModal.type === 1 ? 'Yes' : 'Yes, delete'}
                    </Button>
                </div>
            </Modal>
            <Modal
                width={560}
                maskClosable={false}
                centered
                open={rejectModalOpen}
                onCancel={() => {
                    setRejectModalOpen(false);
                    setRejectionReason('');
                }}
                closeIcon={<CloseCircleOutlined style={{ fontSize: 24, color: '#ff4d4f' }} />}
                footer={null}
            >
                <div className="modal-title">Reject tasker</div>
                <div className="modal-tip tip-font-20">Please provide a reason for rejecting this tasker.</div>
                <Input.TextArea
                    style={{ marginTop: 16 }}
                    rows={4}
                    maxLength={1000}
                    showCount
                    placeholder="Enter rejection reason (required)"
                    value={rejectionReason}
                    onChange={e => setRejectionReason(e.target.value)}
                />
                <div className="flex-center" style={{ marginTop: 30, columnGap: 20 }}>
                    <Button
                        className="submit-btn"
                        onClick={() => {
                            setRejectModalOpen(false);
                            setRejectionReason('');
                        }}
                    >
                        Cancel
                    </Button>
                    <Button className="submit-btn" type="primary" danger onClick={submitReject}>
                        Reject
                    </Button>
                </div>
            </Modal>
            <Modal width={560} maskClosable={false} centered={true} open={videoModal} closeIcon={<></>}>
                <div>
                    <video className="video_box" controls autoPlay src={state.selfIntroductionVideo}></video>
                </div>
                <div className="flex-center" style={{ marginTop: 10, columnGap: 20 }}>
                    <Button
                        className="submit-btn"
                        type="primary"
                        onClick={() => {
                            setVideoModal(false);
                        }}
                    >
                        Close
                    </Button>
                </div>
            </Modal>
        </div>
    );
};
export default TaskerDateil;
